angular
  .module('contrast.services.progressbar', [])
  .factory('ProgressBarService', function () {
    return {
      getType: function (score) {
        var type
        if (score <= 59) {
          type = 'error'
        } else if (score <= 69) {
          type = 'danger'
        } else if (score <= 79) {
          type = 'warning'
        } else if (score <= 89) {
          type = 'info'
        } else {
          type = 'success'
        }

        return type
      },
      getPasswordScoreType: function (score) {
        var type
        if (score <= 59) {
          type = 'error'
        } else if (score <= 89) {
          type = 'middle'
        } else {
          type = 'success'
        }

        return type
      },
      getBackground: function (grade) {
        if ((!grade && !angular.isNumber(grade)) || grade < 0) {
          return 'app-grade-none'
        }

        if (grade > 89) {
          return 'app-grade-a'
        } else if (grade > 79) {
          return 'app-grade-b'
        } else if (grade > 69) {
          return 'app-grade-c'
        } else if (grade > 59) {
          return 'app-grade-d'
        }
        return 'app-grade-f'
      }
    }
  })
